module.exports = __webpack_public_path__ + "img/mirror27.69be80b3.jpg";